import { CanDeactivateGuard } from '../common/can-deactivate/can-deactivate.guard';
import { NgModule } from '@angular/core';
import { mapToCanDeactivate, RouterModule, Routes } from '@angular/router';
import { AnleitungenPageComponent } from './anleitungen-page/anleitungen-page.component';

export const anleitungenRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Netzbetreiber
        path: 'list',
        component: AnleitungenPageComponent,
    },
    {
        path: 'detail',
        component: AnleitungenPageComponent,
        canDeactivate: mapToCanDeactivate([
            CanDeactivateGuard,
        ]),
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(anleitungenRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class NetzbetreiberRoutingModule {
}
